
<template>
  <div class="first-plus">
    <div class="banner">
      <swiper :img-list="bannerList" id="plus-swiper"></swiper>
    </div>
    <div :style="{ backgroundColor: bgc }" class="first-plus-wrapper" v-show="productList.length">
      <list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <product-list :sku-list="productList"></product-list>
      </list>
    </div>
    <FunctionalFloating />
  </div>
</template>

<script>
import { List } from 'vant'
import Swiper from '../../components/swiper'
import ProductList from '../../components/ProductDoubleEach'
import FunctionalFloating from '../../components/activitys/FunctionalFloating'
import api from '../../utils/api'
let flag = false
export default {
  name: 'firstPlus',
  components: {
    List,
    Swiper,
    FunctionalFloating,
    ProductList
  },
  data () {
    return {
      loading: false,
      finished: false,
      bannerList: [],
      productList: [],
      pageNum: 1,
      bgc: 'transparent',
      aid: null
    }
  },
  created () {
    this.$toast.loading({
      duration: 3000000,
      msg: '正在加载...'
    })
    this.getBannerList()
    this.getAcitityProductConfig()
    this.getBgcColor()
  },
  methods: {
    onLoad () {
      // 异步更新数据
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.getProductList(++this.pageNum).then(() => {
          flag = false
          this.loading = false
        })
      }, 500)
    },
    async getBgcColor () {
      const data = await api.getLocationCodingHandler('fighting-0')
      if (data) {
        this.bgc = data[0].configer.coding
      }
    },
    async getBannerList () {
      const data = await api.getLocationCodingHandler('fighting-1')
      if (data) {
        this.bannerList = data
      }
    },
    async getAcitityProductConfig () {
      const data = await api.getLocationCodingHandler('fighting-2')
      if (data) {
        this.cid = data[0].configer.column
        this.getProductList()
      }
    },
    async getProductList (pageNum) {
      const res = await api.getProductList({ id: this.cid, pageNum })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          this.productList = [...this.productList, ...data]
        } else if (code === 9006) {
          if (this.pageNum === 1) {
            this.noData = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.first-plus {
  .banner {
    width: 100%;
    min-height: 3.12rem;
    #plus-swiper {
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  &-wrapper {
    padding: 0 0.2rem 0.23rem;
    background-color: #f82e10;
  }
}
</style>
